import { render } from "./PalliativeCareReport.vue?vue&type=template&id=451cba91&scoped=true"
import script from "./PalliativeCareReport.vue?vue&type=script&lang=js"
export * from "./PalliativeCareReport.vue?vue&type=script&lang=js"

import "./PalliativeCareReport.vue?vue&type=style&index=0&id=451cba91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451cba91"]])

export default __exports__